import {Box, GridItem, IconButton, Input, Text} from "@chakra-ui/react";
import {MarkerSpot, Spot, WiFiApTrigger, Zone} from "../../types";
import {ChangeEvent, KeyboardEvent, useContext} from "react";
import {BiTrash} from "react-icons/bi";
import {AppContext, AppContextI} from "../../context/ContextWrapper";
import {useConfirmDialog} from "../../common/ConfirmDialogProvider";

type Props = {
    object: Spot | Zone,
    trigger: WiFiApTrigger,
    index: number
    updateCall: (object?: Spot | Zone, newObject?: Spot | Zone) => void
}

const WiFiApTriggerDetails = ({object, trigger, index, updateCall}: Props) => {
    const appContext: AppContextI = useContext<AppContextI>(AppContext);
    const {confirm} = useConfirmDialog();

    const handleDelete = async () => {
        if (!object) {
            return;
        }
        const approved = await confirm({
            title: "Delete trigger",
            body: "Are you sure you want to delete this trigger?",
            confirmText: "Delete",
            isDestructive: true
        });
        if (!approved) {
            return;
        }
        const newTriggers = [...object.wiFiTriggers ? object.wiFiTriggers : []]
        const wiFiTriggers = newTriggers.filter((wifiTrig) => wifiTrig.id !== trigger.id);

        updateCall(object, {
            ...object,
            wiFiTriggers: wiFiTriggers
        } as MarkerSpot);
    };

    return <>
        <GridItem marginTop={"16px"} colSpan={4}/>
        <GridItem colStart={1}><Text fontWeight={"semibold"}>WiFi Name:</Text></GridItem>
        <Box ml={"2"}>
            <Input size={"sm"}
                   defaultValue={trigger.name}
                   onBlur={(e: ChangeEvent<HTMLInputElement>) => {
                       if (object) {
                           const newTriggers = [...object.wiFiTriggers ? object.wiFiTriggers : []]
                           newTriggers[index] = {
                               ...trigger,
                               name: e.target.value
                           } as WiFiApTrigger

                           updateCall(object, {
                               ...object,
                               wiFiTriggers: newTriggers
                           } as MarkerSpot);
                       }
                   }
                   }
                   onKeyDown={(e: KeyboardEvent<HTMLInputElement>) => {
                       if (e.key === "Enter") {
                           e.currentTarget.blur();
                       }
                   }}
                   disabled={!appContext.isDraft()}
            />

        </Box>
        <Box/>
        <IconButton variant={"ghost"} aria-label={"Delete"} icon={<BiTrash/>} onClick={handleDelete}
                    disabled={!appContext.isDraft()}
        />
    </>;
}

export default WiFiApTriggerDetails